import { render, staticRenderFns } from "./modern-mild-luxury.vue?vue&type=template&id=14f495b7"
import script from "./modern-mild-luxury.vue?vue&type=script&lang=js"
export * from "./modern-mild-luxury.vue?vue&type=script&lang=js"
import style0 from "./modern-mild-luxury.vue?vue&type=style&index=0&id=14f495b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports